export default "__VITE_ASSET__664e397c__$_#icon-heart__"